export function calculateNetPrice(
  price: string,
  icms: string,
  ipi: string,
  util: string,
  icmsReduction: string
): number {
  const price_with_ipi = parseFloat(price);
  const icmsVal = parseFloat(icms);
  const ipiVal = parseFloat(ipi);
  const icmsReductionVal = parseFloat(icmsReduction);

  if (
    isNaN(price_with_ipi) ||
    price_with_ipi <= 0 ||
    isNaN(icmsVal) ||
    isNaN(ipiVal) ||
    isNaN(icmsReductionVal) ||
    !util
  ) {
    return 0;
  }

  const pis_cofins = 9.25;
  const price_without_ipi = price_with_ipi / (1 + ipiVal / 100);
  const price_plus_ipi = price_without_ipi * (1 + ipiVal / 100);
  const price_ipi = price_plus_ipi - price_without_ipi;

  if (["C", "Z", "D"].includes(util)) {
    const price_icms = ((price_plus_ipi - (price_plus_ipi * icmsReductionVal) / 100) * icmsVal) / 100;
    const price_pis_cofins = (price_plus_ipi - price_icms) * (pis_cofins / 100);
    return price_plus_ipi - price_icms - price_pis_cofins - price_ipi;
  }

  if (["COM", "I"].includes(util)) {
    const price_icms = ((price_without_ipi - (price_without_ipi * icmsReductionVal) / 100) * icmsVal) / 100;
    const price_pis_cofins = (price_without_ipi - price_icms) * (pis_cofins / 100);
    return price_plus_ipi - price_icms - price_pis_cofins - price_ipi;
  }

  return 0;
}
